import React from 'react';
import { MapPin, Clock, Calendar, Video, Users } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { ClassRecord } from '../../data/classes';
interface ClassCardProps {
  classRecord: ClassRecord;
  onClick: (classRecord: ClassRecord) => void;
}
export function ClassCard({
  classRecord,
  onClick
}: ClassCardProps) {
  const isCancelled = classRecord.status === 'cancelled';
  const isJon = classRecord.instructorGroup === 'Jon Kichen';
  return <Card className={`p-6 flex flex-col h-full border-l-4 ${isCancelled ? 'bg-gray-50 border-l-gray-300' : isJon ? 'bg-white border-l-brand-purple-600' : 'bg-white border-l-brand-orange-500'}`} hoverEffect={!isCancelled} data-id="element-72" data-mp="848u1oc59wsy">
      {/* Badges */}
      <div className="flex flex-wrap gap-2 mb-4" data-id="element-73" data-mp="hwob8jfmahcs">
        {isCancelled && <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold bg-red-50 text-red-700 border border-red-200" data-id="element-74" data-mp="mv7ziqhoo58b">
            Cancelled
          </span>}
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-75" data-mp="181ztka768f5j">
          {classRecord.format}
        </span>
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-50 text-blue-700 border border-blue-200" data-id="element-76" data-mp="y1h1wt9d7ud2">
          {classRecord.ceCategory}
        </span>
        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${isJon ? 'bg-brand-purple-50 text-brand-purple-700 border-brand-purple-200' : 'bg-brand-orange-50 text-brand-orange-800 border-brand-orange-200'}`} data-id="element-77" data-mp="1qr63p8twfyfq">
          <span className={`w-2 h-2 rounded-full mr-1.5 ${isJon ? 'bg-brand-purple-600' : 'bg-brand-orange-500'}`} data-id="element-78" data-mp="1czhrz6nkbbza"></span>
          {classRecord.instructorGroup}
        </span>
      </div>

      {/* Title + Price */}
      <div className="flex justify-between items-start gap-4 mb-5" data-id="element-79" data-mp="24pmjdp9qoza0">
        <h3 className={`text-lg font-bold leading-snug ${isCancelled ? 'text-gray-500 line-through' : 'text-gray-900'}`} data-id="element-80" data-mp="2tf6bva1h26l">
          {classRecord.title}
        </h3>
        <div className="text-right flex-shrink-0 max-w-[180px]" data-id="element-81" data-mp="3p8q2nzzougkv">
          <div className={`font-bold break-words leading-snug ${classRecord.price.length > 12 ? 'text-sm' : 'text-lg'} ${classRecord.price === 'Free' ? 'text-green-600' : 'text-gray-900'}`} data-id="element-82" data-mp="3p86sj5ga4whe">
            {classRecord.price}
          </div>
          <div className="text-xs text-gray-500" data-id="element-83" data-mp="3l7em0jysl5ot">{classRecord.hours} hrs</div>
        </div>
      </div>

      {/* Meta details */}
      <div className="space-y-2.5 mb-6 flex-grow" data-id="element-84" data-mp="36bf30ea59l4w">
        <div className="flex items-center text-sm text-gray-700" data-id="element-85" data-mp="3b8p0mh7ot33t">
          <Calendar className="w-4 h-4 mr-2.5 text-brand-purple-400 flex-shrink-0" data-id="element-86" data-mp="3bb1her1pl7fa" />
          <span className="font-medium text-gray-900" data-id="element-87" data-mp="14j0s3z60pgxz">
            {new Date(classRecord.date + 'T00:00:00').toLocaleDateString('en-US', {
            weekday: 'short',
            month: 'short',
            day: 'numeric',
            year: 'numeric'
          })}
          </span>
        </div>
        <div className="flex items-center text-sm text-gray-700" data-id="element-88" data-mp="33ppjyjbm1po5">
          <Clock className="w-4 h-4 mr-2.5 text-brand-purple-400 flex-shrink-0" data-id="element-89" data-mp="33r8xw39snomr" />
          {classRecord.startTime} - {classRecord.endTime}
        </div>
        <div className="flex items-center text-sm text-gray-700" data-id="element-90" data-mp="3cot31nas252n">
          {classRecord.format === 'Zoom' ? <Video className="w-4 h-4 mr-2.5 text-brand-purple-400 flex-shrink-0" data-id="element-91" data-mp="38nzin3wjn8ei" /> : <MapPin className="w-4 h-4 mr-2.5 text-brand-purple-400 flex-shrink-0" data-id="element-92" data-mp="3mns52n11f2go" />}
          {classRecord.location}
        </div>
        <div className="flex items-center text-sm text-gray-700" data-id="element-93" data-mp="1sa0vfnipkil8">
          <Users className="w-4 h-4 mr-2.5 text-brand-purple-400 flex-shrink-0" data-id="element-94" data-mp="1scdbfv4woivn" />
          {classRecord.instructorName}
        </div>
      </div>

      <Button variant={isCancelled ? 'outline' : 'primary'} className="w-full" onClick={() => onClick(classRecord)} data-id="element-95" data-mp="1osv10sw2y6m7">
        {isCancelled ? 'View Details' : 'Register / Details'}
      </Button>
    </Card>;
}